// removed by extract-text-webpack-plugin
module.exports = {"SearchProductItem":"wmf-3BfCPyvr","proName":"wmf-2DU2AfU4","contents":"wmf-3fBmwyUD","info":"wmf-2_Olie1X","footer":"wmf-2Ax_2SDU","price":"wmf-1q3Gpw0L","priceNum":"wmf-2ESTQV_5","code":"wmf-Q-VpNjds"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/udeskSide/components/SearchProductItem.module.less
// module id = 959
// module chunks = 0